import React from 'react';
import { PropTypes } from 'prop-types';

function SideBar({ children }) {
  return <div className="sidebar">{children}</div>;
}

function SideBarSection({ children, title }) {
  return (
    <div className="section">
      <h4>{title}</h4>
      {children}
    </div>
  );
}

SideBarSection.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  title: PropTypes.string.isRequired,
};

SideBar.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

SideBar.Section = SideBarSection;

export default SideBar;
